import * as yup from 'yup'

export const schemaTitulo = yup.object({
  codigo: yup.string().trim().required(),
  projetoId: yup.number().required(),
  anoBase: yup.string().required(),
  quantidade: yup.number().moreThan(0).required(),
})

export const disponivel = (t) => Number(t.quantidadeTotal || 0)
  - Number(t.quantidadeResgatada || 0)
  - Number(t.quantidadeTransferida || 0)

// Título originado por transferência (comprador).
export const ehComprador = (t) => t.tipo === 'comprador' || Boolean(t.tituloOrigemId)

// Título que a empresa gerou/comprou e transferiu (parcial ou integralmente).
export const ehTransferido = (t) => Number(t?.quantidadeTransferida || 0) > 0

// Rótulo de ano-base no formato do dashboard: ano cheio 2025 -> "2024/25".
export const labelAnoBase = (ano) => {
  const n = Number(ano)
  if (!n) return ano || ''
  return `${n - 1}/${String(n).slice(2)}`
}

// Anos-base para os seletores: valor = ano cheio (ex.: "2025"), rótulo "2024/25".
// Mais recente primeiro.
export const anosBase = () => {
  const anoAtual = new Date().getFullYear()
  const lista = []
  for (let ano = anoAtual + 1; ano >= 2014; ano -= 1) {
    lista.push({ value: String(ano), label: labelAnoBase(ano) })
  }
  return lista
}

// status de exibição: usa o status real do título. Um título ativo permanece
// "Ativo" mesmo com resgate/transferência parcial (pedido do cliente — o título
// segue ativo independentemente de não ser mais a quantidade original).
export const statusExibicao = (t) => t.status

const CORES = {
  active: '#219754',
  parcial: '#31ADE3',
  retired: '#9E9E9E',
  exhausted: '#7B65DE',
  suspended: '#EE7D40',
  expired: '#F85453',
  blocked: '#F85453',
  terminated: '#F85453',
}
export const corStatus = (status) => CORES[status] || '#607d8b'

// De onde vêm o código e a ecorregião do título a ser emitido. Enquanto não há
// certificado para o projeto/ano, valem os dados atuais do projeto; a partir do
// primeiro título, valem os do certificado (que é um snapshot e não se atualiza).
export const origemCertificado = ({ certificado, ecorregiaoProjeto }) => {
  if (!certificado) {
    return {
      temCertificado: false, codigo: '', ecorregiao: ecorregiaoProjeto || '', divergente: false,
    }
  }
  const ecorregiao = certificado.ecorregiao?.nome || ''
  return {
    temCertificado: true,
    codigo: certificado.codigo || '',
    ecorregiao,
    divergente: Boolean(ecorregiaoProjeto) && Boolean(ecorregiao) && ecorregiao !== ecorregiaoProjeto,
  }
}

// A API devolve códigos de erro (SaldoInsuficiente, CertificadoCodigoDivergente...)
// que o front traduz; qualquer outra mensagem é exibida como veio.
const ERROS_TRADUZIDOS = [
  'SaldoInsuficiente',
  'CertificadoCodigoDivergente',
  'NumeroTituloEmUso',
  'TituloComResgates',
  'TituloComTitulosGerados',
]
export const traduzErro = (t, mensagem) => (
  ERROS_TRADUZIDOS.includes(mensagem) ? t(`titulosLbc.${mensagem}`) : mensagem
)
